import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db, auth } from '../../firebase';
import { doc, getDoc, collection, getDocs, query, orderBy, setDoc, serverTimestamp } from 'firebase/firestore';
import { FiArrowLeft, FiCalendar, FiMapPin, FiUsers, FiAward, FiFileText, FiX } from 'react-icons/fi';

// --- TELJES FORDÍTÁSI TÁBLÁZAT SZINKRONIZÁLVA (CompetitionOffice.js alapján) ---
const translationMap = {
  // Korosztályok
  'mini': 'Mini',
  'gyerek': 'Gyerek',
  'junior': 'Junior',
  'kadet': 'Kadét',
  'fiatal_felnott': 'Fiatal felnőtt',
  'felnott': 'Felnőtt',
  'szenior': 'Szenior',
  'veteran': 'Veterán',

  // 3D kategóriák
  '3d_hdh_bb': 'BB (Barebow)',
  '3d_hdh_bg': 'BG (Fúvócső)',
  '3d_hdh_cb': 'CB (Csigás Barebow)',
  '3d_hdh_crb': 'CRB (Számszeríj)',
  '3d_hdh_cu': 'CU (Scope-os Csigás)',
  '3d_hdh_hu': 'HU (Vadász Csigás)',
  '3d_hdh_ol': 'OL (Olimpiai)',
  '3d_hdh_pbhb': 'PBHB (Pusztai íj (Tradi))',
  '3d_hdh_trlb': 'TRLB (Longbow)',
  '3d_hdh_trrb': 'TRRB (Vadászreflex)',
  '3d_ifaa_bbc': 'BB(C) (Barebow-Csigás)',
  '3d_ifaa_bbr': 'BB(R) (Barebow-Reflex)',
  '3d_ifaa_bhc': 'BH(C) (Vadászijász-Csigás)',
  '3d_ifaa_bhr': 'BH(R) (Vadászijász-Reflex)',
  '3d_ifaa_bl': 'BL (Korlátozott Vadászijász)',
  '3d_ifaa_bu': 'BU (Bowhunter Unlimited)',
  '3d_ifaa_fsc': 'FS(C) (Korl. nyílt o.-Csigás)',
  '3d_ifaa_fsr': 'FS(R) (Korl. nyílt o.-Reflex)',
  '3d_ifaa_fu': 'FU (Korlátlan nyílt osztály)',
  '3d_ifaa_hb': 'HB (Történelmi íj)',
  '3d_ifaa_hbm': 'HB(M) (Történelmi íj modern)',
  '3d_ifaa_lb': 'LB (Longbow)',
  '3d_ifaa_tr': 'TR (Tradicionális reflex)',

  // Terep kategóriák
  'terep_olimpiai': 'OL (Olimpiai)',
  'terep_csigas': 'CU (Scope-os Csigás)',
  'terep_barebow': 'BB (Barebow)',
  'terep_cb': 'CB (Csigás Barebow)',
  'terep_hu': 'HU (Vadász Csigás)',
  'terep_pbhb': 'PBHB (Pusztai íj (Tradi))',
  'terep_trlb': 'TRLB (Longbow)',
  'terep_trrb': 'TRRB (Vadászreflex)',

  // Pálya kategóriák
  'palya_wa_ol': 'R (Olimpiai reflexíj)',
  'palya_wa_cu': 'CU (Scope-os Csigás)',
  'palya_wa_hu': 'HU (Vadász Csigás)',
  'palya_wa_bb': 'B (Barebow)',
  'palya_wa_trrb': 'TRRB (Vadászreflex)',
  'palya_wa_trlb': 'TRLB (Longbow)',
  'palya_wa_pbhb': 'PBHB (Pusztai íj (Tradi))',
  'palya_wa_crb': 'CRB (Számszeríj)',
  'palya_ifaa_fu': 'FU (Freestyle Unlimited)',
  'palya_ifaa_fsr': 'FSR (FSR (Freestyle Ltd Recurve))',
  'palya_ifaa_fsc': 'FSC (FSC (Freestyle Ltd Compound))',
  'palya_ifaa_bbr': 'BBR (Barebow-Reflex)',
  'palya_ifaa_bbc': 'BBC (Barebow-Csigás)',
  'palya_ifaa_bu': 'BU (Bowhunter Unlimited)',
  'palya_ifaa_bl': 'BL (Bowhunter Limited)',
  'palya_ifaa_bhc': 'BHC (Vadászijász-Csigás)',
  'palya_ifaa_bhr': 'BHR (Vadászijász-Reflex)',
  'palya_ifaa_lb': 'LB (Longbow)',
  'palya_ifaa_hb': 'HB (Historical Bow)',
  'palya_ifaa_tr': 'TR (Traditional Bow)',

  // Történelmi kategóriák
  'tortenelmi_pusztai_modern': 'Modern pusztai íj',
  'tortenelmi_pusztai_termeszetes': 'Természetes pusztai íj',
  'tortenelmi_botij': 'Történelmi hosszúíj / Botíj',
  'tortenelmi_vadaszij': 'Hagyományos vadászíj',
  'tortenelmi_vadaszij_fa': 'Vadászíj fa vesszővel',
  'tortenelmi_vadaszij_karbon': 'Vadászíj karbonvesszővel',
  'tortenelmi_ij': 'Történelmi íj',
  'tortenelmi_szamszerij': 'Történelmi számszeríj',
  'tortenelmi_bb': 'BB (Barebow)',

  // Örömijász kategóriák
  'orom_wa_ol': 'OL (Olimpiai reflexíj)',
  'orom_wa_cu': 'CU (Scope-os Csigás)',
  'orom_wa_hu': 'HU (Vadász Csigás)',
  'orom_wa_cb': 'CB (Csigás Barebow)',
  'orom_wa_bb': 'BB (Barebow)',
  'orom_wa_trrb': 'TRRB (Vadászreflex)',
  'orom_wa_trlb': 'TRLB (Longbow)',
  'orom_wa_pbhb': 'PBHB (Pusztai íj)',
  'orom_vadaszij_fa': 'Vadászíj fa vesszővel',
  'orom_vadaszij_karbon': 'Vadászíj karbonvesszővel',
  'orom_tortenelmi_ij': 'Történelmi íj',
  'orom_wa_crb': 'CRB (Számszeríj)',
  'orom_wa_bg': 'BG (Fúvócső)',

  // Egyéb
  'egyeb_wa_ol': 'OL (Olimpiai reflexíj)',
  'egyeb_wa_cu': 'CU (Scope-os Csigás)',
  'egyeb_wa_hu': 'HU (Vadász Csigás)',
  'egyeb_wa_cb': 'CB (Csigás Barebow)',
  'egyeb_wa_bb': 'BB (Barebow)',
  'egyeb_wa_trrb': 'TRRB (Vadászreflex)',
  'egyeb_wa_trlb': 'TRLB (Longbow)',
  'egyeb_wa_pbhb': 'PBHB (Pusztai íj)',
  'egyeb_wa_crb': 'CRB (Számszeríj)',
  'egyeb_wa_bg': 'BG (Fúvócső)',
  'egyeb_altalanos': 'Egyéb Általános'
};

const getColorForZoneValue = (val) => {
  const v = val?.toString().toUpperCase();
  if (v === '11' || v === 'X') return '#4CAF50';
  if (v === '10' || v === '9') return '#FFD700';
  if (v === '8' || v === '7') return '#F44336';
  if (v === '6' || v === '5') return '#1976D2';
  return '#9E9E9E';
};

const getCompetitionTypeDisplay = (rawType) => {
    const type = rawType?.toLowerCase() || '';
    if (type.includes('3d')) return { label: '3D', color: '#28a745' };
    if (type.includes('palya')) return { label: 'Pálya', color: '#007bff' };
    if (type.includes('orom')) return { label: 'Örömijász', color: '#ffc107' };
    if (type.includes('tortenelmi')) return { label: 'Történelmi', color: '#dc3545' };
    if (type.includes('terep')) return { label: 'Terep', color: '#6d4c41' };
    return { label: rawType || 'Egyéb', color: '#9c27b0' };
};

// --- GLOBÁLIS KONSTANSOK A RENDEZÉSHEZ ---
const AGE_ORDER = {
  'mini': 1, 'gyerek': 2, 'junior': 3, 'kadet': 4, 'ifi': 5,
  'fiatal_felnott': 6, 'felnott': 7, 'szenior': 8, 'veteran': 9
};

const ClosedCompetitionLeaderboard = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [competition, setCompetition] = useState(null);
    const [participants, setParticipants] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [activeTab, setActiveTab] = useState('results'); // MÓDOSÍTVA: Eredmények az alapértelmezett
    const [showTargetsModal, setShowTargetsModal] = useState(false);

    const [hasParticipated, setHasParticipated] = useState(false);
    const [alreadyRated, setAlreadyRated] = useState(false);
    const [ratingsForm, setRatingsForm] = useState({
        parking: 0,
        office: 0,
        organization: 0,
        course: 0,
        catering: 0
    });
    const [isSubmittingRating, setIsSubmittingRating] = useState(false);

    useEffect(() => {
        const checkParticipantAndRating = async () => {
            const user = auth.currentUser;
            if (!user) return;
            try {
                const pDoc = await getDoc(doc(db, "events_closed", id, "participants", user.uid));
                if (pDoc.exists()) {
                    setHasParticipated(true);
                    const rDoc = await getDoc(doc(db, "events_closed", id, "ratings", user.uid));
                    if (rDoc.exists()) {
                        setAlreadyRated(true);
                        const rData = rDoc.data();
                        setRatingsForm({
                            parking: rData.parking || 0,
                            office: rData.office || 0,
                            organization: rData.organization || 0,
                            course: rData.course || 0,
                            catering: rData.catering || 0
                        });
                    }
                }
            } catch (e) {
                console.error("Hiba a részvétel ellenőrzésekor:", e);
            }
        };
        checkParticipantAndRating();
    }, [id]);

    const handleSumbitRating = async () => {
        const user = auth.currentUser;
        if (!user) return;
        setIsSubmittingRating(true);
        try {
            await setDoc(doc(db, "events_closed", id, "ratings", user.uid), {
                parking: ratingsForm.parking,
                office: ratingsForm.office,
                organization: ratingsForm.organization,
                course: ratingsForm.course,
                catering: ratingsForm.catering,
                updatedAt: serverTimestamp()
            }, { merge: true });

            setAlreadyRated(true);
            alert("Köszönjük a verseny értékelését! ⭐");
        } catch (e) {
            console.error("Hiba az értékelés mentésekor:", e);
            alert("Hiba történt az értékelés mentése során.");
        } finally {
            setIsSubmittingRating(false);
        }
    };

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);

        const fetchResults = async () => {
            setLoading(true);
            try {
                const compDoc = await getDoc(doc(db, "events_closed", id));
                if (!compDoc.exists()) {
                    alert("A verseny nem található!");
                    navigate('/eredmenyek');
                    return;
                }
                setCompetition(compDoc.data());

                const partsSnap = await getDocs(query(collection(db, "events_closed", id, "participants"), orderBy("rank", "asc")));
                const partsData = partsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })).filter(p => p.totalScore !== undefined && p.totalScore !== null && p.rank !== undefined && p.rank !== null);
                setParticipants(partsData);
            } catch (err) {
                console.error("Error fetching results:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchResults();

        return () => window.removeEventListener('resize', handleResize);
    }, [id]);

    const groupedResults = useMemo(() => {
        const groups = {};
        participants.forEach(p => {
            // JAVÍTÁS: A csoportosítás alapja a lefordított íjkategória legyen, speciális elválasztóval
            const bowLabel = translationMap[p.bowCategory?.toLowerCase()] || p.bowCategory || 'Egyéb';
            const ageCat = p.ageCategory || 'felnott';
            const gender = p.gender || 'Férfi';

            const key = `${bowLabel}|${ageCat}|${gender}`;
            if (!groups[key]) {
                groups[key] = {
                    bowLabel,
                    bowCategory: p.bowCategory,
                    ageCategory: ageCat,
                    gender: gender,
                    members: []
                };
            }
            groups[key].members.push(p);
        });

        return Object.values(groups).sort((a, b) => {
            // 1. Íjkategória (ABC - Lefordított név alapján)
            const bowComp = (a.bowLabel || '').localeCompare(b.bowLabel || '', 'hu');
            if (bowComp !== 0) return bowComp;

            // 2. Korosztály (Súlyozott sorrend a globális konstansból)
            // Ez garantálja, hogy a Gyerek (2) megelőzze a Felnőttet (7)
            const ageA = AGE_ORDER[a.ageCategory?.toLowerCase()] || 99;
            const ageB = AGE_ORDER[b.ageCategory?.toLowerCase()] || 99;
            if (ageA !== ageB) return ageA - ageB;

            // 3. Nem (Nők előre)
            const genA = a.gender === 'Nő' ? 0 : 1;
            const genB = b.gender === 'Nő' ? 0 : 1;
            return genA - genB;
        });
    }, [participants]);

    if (loading) return <div style={centerStyle}>Eredménytábla betöltése... 🏹</div>;
    if (!competition) return null;

    return (
        <div style={pageContainerStyle} className="force-light-theme">
            <button onClick={() => navigate('/eredmenyek')} style={backBtnStyle}>
                <FiArrowLeft /> Vissza a listához
            </button>

            <div style={headerCardStyle}>
                <h1 style={titleStyle}>{competition.competitionName}</h1>
                <div style={{ color: '#28a745', fontWeight: 'bold', marginBottom: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    <FiAward size={24} /> HIVATALOS VÉGEREDMÉNY
                </div>
                <div style={{
                    ...headerDetailsStyle,
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? '10px' : '30px'
                }}>
                    <span><FiCalendar /> {competition.competitionDate}</span>
                    <span style={{
                        color: getCompetitionTypeDisplay(competition.competitionType).color,
                        fontWeight: 'bold',
                        backgroundColor: '#f8f9fa',
                        padding: '2px 8px',
                        borderRadius: '6px',
                        border: `1px solid ${getCompetitionTypeDisplay(competition.competitionType).color}22`
                    }}>
                        {getCompetitionTypeDisplay(competition.competitionType).label}
                    </span>
                    <span><FiMapPin /> {competition.location?.split(',')[0]}</span>
                    <span><FiUsers /> {participants.length} résztvevő</span>
                </div>

                {/* --- TÁVOK GOMB (CSAK HA PUBLIKÁLVA VAN) --- */}
                {competition.targetsPublished && (
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <button
                      onClick={() => setShowTargetsModal(true)}
                      style={{
                        backgroundColor: '#b30000',
                        color: '#fff',
                        border: 'none',
                        padding: '10px 30px',
                        borderRadius: '25px',
                        fontWeight: 'bold',
                        fontSize: '1rem',
                        cursor: 'pointer',
                        boxShadow: '0 4px 10px rgba(179, 0, 0, 0.3)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}
                    >
                      <FiMapPin /> TÁVOK
                    </button>
                  </div>
                )}
            </div>

            {/* --- ÉRTÉKELŐ KÁRTYA (CSAK RÉSZTVEVŐKNEK) --- */}
            {hasParticipated && (
                <div style={{ backgroundColor: '#fff', borderRadius: '15px', padding: '20px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', marginBottom: '20px', textAlign: 'center', border: '1px solid #eee' }}>
                    {alreadyRated ? (
                        <div style={{ backgroundColor: '#f0fff4', color: '#276749', padding: '15px', borderRadius: '10px', fontWeight: 'bold', border: '1px solid #c6f6d5' }}>
                            ⭐ Köszönjük, te már értékelted ezt a versenyt!
                        </div>
                    ) : (
                        <div>
                            <h3 style={{ margin: '0 0 15px 0', color: '#b30000', fontSize: '1.1rem' }}>⭐ Értékeld a versenyt</h3>
                            {[
                                { key: 'parking', label: 'Parkolás' },
                                { key: 'office', label: 'Versenyiroda' },
                                { key: 'organization', label: 'Szervezés' },
                                { key: 'course', label: 'Pálya' },
                                { key: 'catering', label: 'Vendéglátás' }
                            ].map(item => (
                                <div key={item.key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', paddingBottom: '8px', borderBottom: '1px solid #f9f9f9' }}>
                                    <span style={{ fontWeight: 'bold', fontSize: '0.9rem', color: '#333' }}>{item.label}</span>
                                    <div style={{ display: 'flex', gap: '5px', cursor: 'pointer' }}>
                                        {[1, 2, 3, 4, 5].map(star => (
                                            <span
                                                key={star}
                                                onClick={() => setRatingsForm(prev => ({ ...prev, [item.key]: star }))}
                                                style={{ fontSize: '1.3rem', color: star <= ratingsForm[item.key] ? '#FFD700' : '#CBD5E0' }}
                                            >
                                                ★
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            ))}

                            <button
                                onClick={handleSumbitRating}
                                disabled={isSubmittingRating}
                                style={{
                                    marginTop: '15px', width: '100%', padding: '12px',
                                    backgroundColor: '#b30000', color: 'white', border: 'none',
                                    borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer'
                                }}
                            >
                                {isSubmittingRating ? "Küldés..." : "Értékelés küldése"}
                            </button>
                        </div>
                    )}
                </div>
            )}

            {/* TAB GOMBOK */}
            <div style={{
                ...tabContainerStyle,
                marginTop: isMobile ? '0' : '2rem',
                gap: isMobile ? '0' : '20px',
                borderBottom: isMobile ? 'none' : '2px solid #eee',
                backgroundColor: isMobile ? '#fff' : 'transparent',
                padding: isMobile ? '10px 16px 0 16px' : '0',
                borderRadius: isMobile ? '12px 12px 0 0' : '0',
                boxShadow: isMobile ? '0 -4px 10px rgba(0,0,0,0.02)' : 'none'
            }}>
                {/* EREDMÉNYEK TAB (Mostantól az első) */}
                <div
                    style={{
                        flex: isMobile ? 1 : 'none',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        cursor: 'pointer'
                    }}
                    onClick={() => setActiveTab('results')}
                >
                    <button style={{
                        ...tabButtonStyle(activeTab === 'results'),
                        color: (activeTab === 'results') ? '#b30000' : '#666',
                        borderBottom: 'none',
                        padding: isMobile ? '8px' : '10px 20px',
                        fontSize: isMobile ? '13px' : '1rem'
                    }}>
                        Eredmények
                    </button>
                    {isMobile && (
                        <div style={{
                            width: '60px',
                            height: '3px',
                            backgroundColor: '#b30000',
                            visibility: activeTab === 'results' ? 'visible' : 'hidden'
                        }} />
                    )}
                </div>

                {/* LEÍRÁS TAB (Mostantól a második) */}
                <div
                    style={{
                        flex: isMobile ? 1 : 'none',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        cursor: 'pointer'
                    }}
                    onClick={() => setActiveTab('description')}
                >
                    <button style={{
                        ...tabButtonStyle(activeTab === 'description'),
                        color: (activeTab === 'description') ? '#b30000' : '#666',
                        borderBottom: 'none',
                        padding: isMobile ? '8px' : '10px 20px',
                        fontSize: isMobile ? '13px' : '1rem'
                    }}>
                        Leírás
                    </button>
                    {isMobile && (
                        <div style={{
                            width: '60px',
                            height: '3px',
                            backgroundColor: '#b30000',
                            visibility: activeTab === 'description' ? 'visible' : 'hidden'
                        }} />
                    )}
                </div>
            </div>

            <div style={{
                backgroundColor: isMobile ? '#fff' : 'transparent',
                padding: isMobile ? '16px' : '0',
                borderRadius: isMobile ? '0 0 12px 12px' : '0',
                boxShadow: isMobile ? '0 4px 10px rgba(0,0,0,0.05)' : 'none'
            }}>
                {activeTab === 'description' && (
                    <div
                        className="competition-description-html"
                        style={descriptionStyle}
                        dangerouslySetInnerHTML={{ __html: competition.competitionDescription || 'Nincs leírás megadva.' }}
                    />
                )}

                <style>{`
                    .competition-description-html ul,
                    .competition-description-html ol {
                        padding-left: 20px;
                        margin-bottom: 15px;
                    }
                    .competition-description-html li {
                        margin-bottom: 5px;
                    }
                    .competition-description-html h1,
                    .competition-description-html h2,
                    .competition-description-html h3 {
                        margin-top: 20px;
                        margin-bottom: 10px;
                        line-height: 1.2;
                    }
                `}</style>

                {activeTab === 'results' && (
                    <div style={resultsContainerStyle}>
                        {groupedResults.map((group, gIdx) => (
                            <div key={gIdx} style={categoryCardStyle}>
                                <h2 style={categoryTitleStyle}>
                                    {translationMap[group.bowCategory?.toLowerCase()] || group.bowCategory || 'Egyéb'} - {translationMap[group.ageCategory?.toLowerCase()] || group.ageCategory || 'Felnőtt'} - {group.gender || 'Férfi'}
                                </h2>

                                <div style={{ overflowX: 'auto' }}>
                                    <table style={tableStyle}>
                                        <thead>
                                            <tr>
                                                <th style={thStyleCenter}>#</th>
                                                <th style={thStyle}>Név</th>
                                                <th style={thStyleRight}>Összesen</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {group.members.map((p, pIdx) => {
                                                const hasDetailedInfo = (p.finalShots && p.finalShots.length > 0) || (p.hitZoneCounts && Object.values(p.hitZoneCounts).some(count => count > 0));

                                                return (
                                                    <tr
                                                        key={pIdx}
                                                        style={{
                                                            ...(p.rank <= 3 ? podiumRowStyle(p.rank) : trStyle),
                                                            cursor: hasDetailedInfo ? 'pointer' : 'default'
                                                        }}
                                                        onClick={() => {
                                                            if (hasDetailedInfo) {
                                                                navigate(`/eredmeny/${id}/resztvevo/${p.id}`);
                                                            }
                                                        }}
                                                    >
                                                        <td style={tdStyleCenter}>
                                                            {p.rank === 1 ? '🥇' : p.rank === 2 ? '🥈' : p.rank === 3 ? '🥉' : `${p.rank}.`}
                                                        </td>
                                                        <td style={tdStyle}>
                                                            <div style={{ fontWeight: 'bold' }}>{p.fullName || 'Névtelen nevező'}</div>
                                                            <div style={{ fontSize: '0.75rem', color: '#888' }}>{p.club || 'Egyéni induló'}</div>
                                                        </td>
                                                        <td style={tdStyleRight}>
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '6px', whiteSpace: 'nowrap', flexShrink: 0 }}>
                                                                <strong>{p.totalScore}p</strong>
                                                                {hasDetailedInfo && (() => {
                                                                    // MINTAFELISMERŐ: Ha a lövések érték szerint sorba vannak rendezve, az manuális
                                                                    const shots = p.finalShots || [];
                                                                    const isSuspicious = shots.length > 5 && shots.every((s, i, arr) =>
                                                                        i === 0 || (parseInt(s.sum) >= parseInt(arr[i-1].sum))
                                                                    );

                                                                    const isManual = p.isManuallyEdited || isSuspicious;

                                                                    return (
                                                                        <FiFileText
                                                                            size={16}
                                                                            color={isManual ? "#FFC107" : "#28A745"}
                                                                            title={isManual ? "Manuálisan rögzített részletes adatok" : "Hivatalos QR-kódos adatok"}
                                                                        />
                                                                    );
                                                                })()}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <div style={{ height: '80px' }} />

            {/* --- PÁLYAADATOK MODAL --- */}
            {showTargetsModal && (
                <div style={modalOverlayStyle} onClick={() => setShowTargetsModal(false)}>
                    <div style={{ ...modalContentStyle(isMobile), maxWidth: '600px' }} onClick={(e) => e.stopPropagation()}>
                        <div style={modalHeaderStyle(isMobile)}>
                            <h3 style={{ margin: 0 }}>Pályaadatok (Távolságok)</h3>
                            <div
                                style={{ cursor: 'pointer', backgroundColor: 'rgba(255,255,255,0.2)', borderRadius: '50%', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                onClick={() => setShowTargetsModal(false)}
                            >
                                <FiX size={20} color="#fff" />
                            </div>
                        </div>
                        <div style={modalBodyStyle(isMobile)}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ borderBottom: '2px solid #eee' }}>
                                        <th style={{ padding: '10px', textAlign: 'center', width: '40px' }}>#</th>
                                        <th style={{ padding: '10px', textAlign: 'left' }}>Cél</th>
                                        <th style={{ padding: '10px', textAlign: 'center', color: '#b30000' }}>Piros</th>
                                        <th style={{ padding: '10px', textAlign: 'center', color: '#007bff' }}>Kék</th>
                                        <th style={{ padding: '10px', textAlign: 'center', color: '#666' }}>Fehér</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.from({ length: Number(competition.numberOfTargets) || 0 }, (_, i) => i + 1).map(num => (
                                        <tr key={num} style={{ borderBottom: '1px solid #f9f9f9' }}>
                                            <td style={{ padding: '12px 5px', textAlign: 'center', fontWeight: 'bold', backgroundColor: '#f8f8f8' }}>{num}.</td>
                                            <td style={{ padding: '12px 10px', textAlign: 'left', fontWeight: '500' }}>
                                                {competition.targetDetails?.[num]?.name || '-'}
                                            </td>
                                            <td style={{ padding: '12px 5px', textAlign: 'center', fontWeight: 'bold' }}>
                                                {competition.targetDetails?.[num]?.distRed ? `${competition.targetDetails[num].distRed}m` : '-'}
                                            </td>
                                            <td style={{ padding: '12px 5px', textAlign: 'center', fontWeight: 'bold' }}>
                                                {competition.targetDetails?.[num]?.distBlue ? `${competition.targetDetails[num].distBlue}m` : '-'}
                                            </td>
                                            <td style={{ padding: '12px 5px', textAlign: 'center', fontWeight: 'bold' }}>
                                                {competition.targetDetails?.[num]?.distWhite ? `${competition.targetDetails[num].distWhite}m` : '-'}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div style={modalFooterStyle(isMobile)}>
                            <button style={modalCancelButtonStyle} onClick={() => setShowTargetsModal(false)}>Bezárás</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

// --- STÍLUSOK ---
const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000, backdropFilter: 'blur(3px)' };

const modalContentStyle = (isMobile) => ({
    backgroundColor: '#fff', width: '90%', maxWidth: '450px', borderRadius: '15px',
    boxShadow: '0 15px 35px rgba(0,0,0,0.3)', overflow: 'hidden', textAlign: 'center',
    maxHeight: isMobile ? '75vh' : '90vh', display: 'flex', flexDirection: 'column'
});

const modalHeaderStyle = (isMobile) => ({
    backgroundColor: '#b30000', color: '#fff', padding: isMobile ? '8px 15px' : '15px 20px',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    flexShrink: 0
});

const modalBodyStyle = (isMobile) => ({ padding: isMobile ? '15px' : '25px', overflowY: 'auto', flex: 1, textAlign: 'center' });

const modalFooterStyle = (isMobile) => ({
    padding: isMobile ? '10px 15px' : '15px 25px',
    backgroundColor: '#f9f9f9',
    borderTop: '1px solid #eee',
    flexShrink: 0
});

const modalCancelButtonStyle = { width: '100%', backgroundColor: '#eee', color: '#333', border: 'none', padding: '12px', borderRadius: '10px', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer' };

const pageContainerStyle = { padding: '20px', maxWidth: '1000px', margin: '0 auto', backgroundColor: '#f4f6f8', minHeight: '100vh' };
const backBtnStyle = { display: 'flex', alignItems: 'center', gap: '8px', border: 'none', background: 'none', color: '#666', fontWeight: 'bold', cursor: 'pointer', marginBottom: '20px' };
const headerCardStyle = { backgroundColor: '#fff', borderRadius: '15px', padding: '25px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', marginBottom: '30px', textAlign: 'center', borderTop: '5px solid #b30000' };
const titleStyle = { margin: '0 0 5px 0', color: '#b30000', fontSize: '2rem', fontWeight: '900' };
const headerDetailsStyle = { display: 'flex', justifyContent: 'center', gap: '30px', color: '#666', fontSize: '0.95rem' };

const tabContainerStyle = {
    display: 'flex',
    gap: '20px',
    borderBottom: '2px solid #eee',
    marginBottom: '1.5rem',
    marginTop: '2rem'
};

const tabButtonStyle = (isActive) => ({
    padding: '10px 20px',
    border: 'none',
    background: 'none',
    fontSize: '1rem',
    fontWeight: 'bold',
    color: isActive ? '#b30000' : '#666',
    borderBottom: isActive ? '3px solid #b30000' : '3px solid transparent',
    cursor: 'pointer',
    marginBottom: '-2px',
    transition: 'all 0.2s'
});

const descriptionStyle = {
    lineHeight: '1.6',
    color: '#444',
    textAlign: 'left',
    overflowWrap: 'anywhere',
    whiteSpace: 'pre-wrap',
    wordBreak: 'normal'
};

const resultsContainerStyle = { display: 'flex', flexDirection: 'column', gap: '25px' };
const categoryCardStyle = { backgroundColor: '#fff', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' };
const categoryTitleStyle = { margin: '0 0 15px 0', paddingBottom: '10px', borderBottom: '2px solid #eee', color: '#333', fontSize: '1.1rem', fontWeight: 'bold' };
const tableStyle = { width: '100%', borderCollapse: 'collapse' };
const thStyle = { textAlign: 'left', padding: '12px 8px', color: '#888', fontSize: '0.8rem', textTransform: 'uppercase' };
const thStyleCenter = { ...thStyle, textAlign: 'center' };
const thStyleRight = { ...thStyle, textAlign: 'right' };
const tdStyle = { padding: '12px 8px', borderBottom: '1px solid #f0f0f0', fontSize: '0.9rem' };
const tdStyleCenter = { ...tdStyle, textAlign: 'center' };
const tdStyleRight = { ...tdStyle, textAlign: 'right', color: '#b30000' };
const trStyle = { transition: '0.2s' };
const podiumRowStyle = (rank) => ({
    backgroundColor: rank === 1 ? '#fffcf0' : rank === 2 ? '#f8f9fa' : '#fff9f5',
    transition: '0.2s'
});
const centerStyle = { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: '#666' };

export default ClosedCompetitionLeaderboard;
